import { render, staticRenderFns } from "./ChickTransfer.vue?vue&type=template&id=4ab7028f&scoped=true&"
import script from "./ChickTransfer.vue?vue&type=script&lang=js&"
export * from "./ChickTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ChickTransfer.vue?vue&type=style&index=0&id=4ab7028f&lang=scss&scoped=true&"
import style1 from "./ChickTransfer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab7028f",
  null
  
)

export default component.exports